import React from 'react';

import css from './SmartResponse.module.css';
import ReactMarkdown from 'react-markdown'

function SmartResponse({ question, response }) {
  if (!response) return null;

  return (
    <div className={css.main}>
      <div className={css.title} data-cy="semantic-search-response">
        <span role="img" aria-label="sparkle icon" className={css.icon}>
          ✨
        </span>
        {question}
      </div>
      <ReactMarkdown className={css.response} children={response}/>
    </div>
  );
}

export default SmartResponse;
